<template lang="html">
	<div class="apps-container">
		<div class="parent scroll-light">
			<div class="grid-box">
				<div
					class="app-container"
					:data-groups="grupo(contenido.area_curricular)"
					v-for="contenido in contenidos"
					:key="contenido.id"
				>
					<div
						tabindex="1"
						class="app-icon"
						:class="{ seleccionado: contenido == contenido_seleccionado }"
						@click="seleccionar(contenido)"
					>
						<img
							:src="icono(contenido)"
						/>
					</div>
					<span class="app-label">{{ contenido.nombre }}</span>
				</div>
			</div>
		</div>
		<div class="description-box">
			<div v-if="contenido_seleccionado" class="description-container">
				<div class="logo">
					<!-- <img :src="contenido_seleccionado.icono" alt /> -->
					<img :src="icono(contenido_seleccionado)" alt />
				</div>
				<div class="texto">
					<div class="texto-encabezado">
						<h2>{{ contenido_seleccionado.nombre }}</h2>
					</div>
					<div class="texto-cuerpo scroll-light">
						<p>{{ contenido_seleccionado.descripcion }}</p>
					</div>
					<div class="texto-pie">
						<button v-if="contenido_seleccionado.guia" class="btn btn-primary" @click="verGuia">Ver Guía</button>
						<button class="btn btn-primary" @click="lanzar">
							<spinner v-if="cargando"/>
							<span v-else>Lanzar</span>
						</button>
					</div>
				</div>
			</div>
			<div v-else class="description-container">
				<div class="texto">
					<div class="texto-encabezado">
						<h2>{{tituloBienvenida}}</h2>
					</div>
					<div class="texto-cuerpo scroll-light">
						<p>{{textoBienvenida}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Spinner from "@/components/Spinner.vue";
import Shuffle from "shufflejs";
// import {shell} from 'electron'
import isElectron from "is-electron";
var shuffleInstance;

export default {
    name: "AppsContainer",
    props: [
        "eventBus",
        "contenidos",
        "areas_seleccionadas",
        "contenido_seleccionado"
    ],
    components: { Spinner },
    data: function() {
        return {
            cargando: false
        };
    },
    computed: {
        tituloBienvenida() {
            return this.$store.getters.presidenciaScreen.tituloBienvenida;
        },
        textoBienvenida() {
            return this.$store.getters.presidenciaScreen.textoBienvenida;
        }
    },
    methods: {
        grupo(grupo) {
            return `["${grupo}"]`;
        },
        icono(contenido) {
            try {
                return require(`@/assets/img/contenidos_icons/${contenido.icono}`);
            } catch (e) {
                return require(`@/assets/img/contenidos_icons/default.png`);
            }
        },
        seleccionar(contenido) {
            this.$globalEvent.$emit("popSound");
            this.$emit("seleccionar", contenido);
        },
        lanzar() {
            if (isElectron()) {
                if (this.contenido_seleccionado.contenidos) {
                    this.$globalEvent.$emit("abrirMenuPresidencia");
                } else {
                    this.temporizador();
                    const open = require("open");
                    open(this.contenido_seleccionado.ruta);
                }
            } else {
                if (this.contenido_seleccionado.contenidos) {
                    this.$globalEvent.$emit("abrirMenuPresidencia");
                } else {
                    if (!this.contenido_seleccionado.ruta_web) {
                        alert(
                            "Este contenido solo se encuentra disponible de manera offline en los dispositivos de Computadores para Educar."
                        );
                        return false;
                    }
                    let win = window.open(
                        this.contenido_seleccionado.ruta_web,
                        "_blank"
                    );
                    win.focus();
                }
            }
        },
        verGuia() {
            this.eventBus.$emit("abrirGuia");
        },
        temporizador() {
            this.cargando = true;
            setTimeout(() => {
                this.cargando = false;
            }, 7000);
        }
    },
    created() {},
    mounted() {
        var element = document.querySelector(".grid-box");
        shuffleInstance = new Shuffle(element, {
            itemSelector: ".app-container",
            sizer: ".app-container",
            speed: 500,
            throttleTime: 500
        });
    },
    watch: {
        areas_seleccionadas: function(areas) {
            this.$globalEvent.$emit("slideSound");
            shuffleInstance.filter(areas);
            shuffleInstance.update();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
.apps-container {
    z-index: 1;
    width: 900px;
    max-width: 90%;
    // margin-right: 80px;
    height: 400px;
    max-height: calc(95% - 100px);
    margin-bottom: 100px;
    border: 30px solid rgba(0, 91, 156, 0.25);
    background-color: rgba(0, 91, 156, 0.5);
    box-sizing: border-box;
    border-radius: 0px 100px 0px 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;
    @include mobile {
        flex-direction: column;
        // justify-content: space-around;
        max-width: calc(95% - 60px);
        width: calc(95% - 60px);
        margin-right: 60px;
        height: calc(95% - 50px);
        max-height: calc(95% - 50px);
        margin-bottom: 50px;
    }
    @include mobile-s {
        border-radius: 0px 60px 0px 80px;
        border-width: 10px;
    }
}

.parent {
    -webkit-overflow-scrolling: touch;
    width: 60%;
    height: 100%;
    overflow-x: auto;
    // padding-top: 15px;
    // padding-bottom: 15px;
    mask-image: -webkit-linear-gradient(
        top,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 5%,
        rgba(0, 0, 0, 1) 95%,
        rgba(0, 0, 0, 0) 100%
    );
    @include mobile {
        width: 100%;
        height: 60%;
    }
}

.grid-box {
    width: 100%;
    // padding-top: 15px;
    // height: 80%;
    // background-color: rgba(0, 156, 8, 0.5);
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 15px;
    box-sizing: border-box;
}

.app-container {
    box-sizing: border-box;
    color: white;
    text-align: center;
    float: left;
    position: relative;
    float: left;
    min-height: 1px;
    width: 20%;
    padding-left: 5px;
    padding-right: 5px;
    /* Space between tiles */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // margin-top: 8px;
    padding: 10px;
    @include desktop {
        width: 20%;
    }
    @include tablet-m {
        width: 25%;
    }
    @include mobile-s {
        width: 33%;
    }
    @include mobile-vs {
        width: 50%;
    }
}

.app-icon {
    width: 70px;
    height: 70px;
    border-radius: 15px;
    background-color: white;
    overflow: hidden;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include mobile-s {
        width: 60px;
        height: 60px;
    }
}

.app-icon:hover {
    cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
}

.app-icon:focus,
.app-icon.seleccionado {
    box-shadow: 0px 0px 5px 4px #18eeff;
}

.app-icon > img {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
}

.description-box {
    width: 40%;
    height: 100%;
    // background-color: rgba(156, 0, 0, 0.5);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    color: white;
    padding-left: 15px;
    @include mobile {
        padding-top: 15px;
        padding-left: 0px;
        width: 100%;
        height: 40%;
    }
}

.description-container {
    width: 100%;
    height: 100%;
    border: 2px dashed white;
    border-radius: 15px 70px 15px 15px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    @include mobile {
        flex-direction: row;
        width: 100%;
        border-radius: 15px 15px 15px 70px;
    }
}

.logo {
    width: 100%;
    height: fit-content;
    max-height: 40%;
    @include mobile {
        width: auto;
        max-width: 40%;
        max-height: 90%;
        align-self: center;
    }
}

.logo > img {
    background-color: white;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 90%;
    border-radius: 15px;
}

.texto {
    min-height: 60%;
    display: flex;
    flex-direction: column;
    @include mobile {
        width: 100%;
        min-width: 60%;
        max-height: 100%;
        align-self: center;
    }
}

.texto-encabezado,
.texto-pie {
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
}

.texto-cuerpo {
    text-align: justify;
    flex-shrink: 1;
    overflow-y: auto;
    mask-image: -webkit-linear-gradient(
        top,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 5%,
        rgba(0, 0, 0, 1) 95%,
        rgba(0, 0, 0, 0) 100%
    );
}

.texto-cuerpo > p {
    margin: 0px;
}

.texto h2 {
    margin: 0px;
}

.logo,
.texto-cuerpo,
.texto-pie {
    box-sizing: border-box;
    padding: 10px;
}

img {
    pointer-events: none;
}
</style>
